import { tryLoadDependencies, WebAwesomeComponent } from '../Global/loadDependency'
import { getTemplateNavHeaderStyles } from './NavHeader.styles'

const t = document.createElement('template')
t.innerHTML = `
  <!-- Search Icon -->
  <wa-icon
    name="search"
    class="header-icon"
    label="Search"
    aria-label="Search"
    alt="Search"
    aria-hidden="false"
    focusable="true"
    tabindex="0"
  ></wa-icon>
`

class NavHeaderUtilitySearch extends HTMLElement {
  private _iconEl: EventTarget | null = null
  private isSearchBoxVisible = false

  constructor() {
    super()

    tryLoadDependencies(document, [WebAwesomeComponent.Icon])

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    const icon = this.shadowRoot?.querySelector('wa-icon')
    if (icon) {
      this._iconEl = icon
      icon.addEventListener('click', this.onIconClick)
      icon.addEventListener('keydown', this.onIconKeydown as EventListener)
    }

    // Initialize search state
    this.eventStateChange()
  }

  disconnectedCallback() {
    if (this._iconEl) {
      this._iconEl.removeEventListener('click', this.onIconClick)
      this._iconEl.removeEventListener('keydown', this.onIconKeydown as EventListener)
      this._iconEl = null
    }

    document.removeEventListener('click', this.onDocumentClick, true)
  }

  private eventStateChange() {
    this.updateCSSClasses()
    this.dispatchSearchStateEvent()
  }

  private updateCSSClasses() {
    const icon = this.shadowRoot?.querySelector('wa-icon')

    if (icon != null) {
      if (this.isSearchBoxVisible) {
        icon.classList.add('search-active')
        icon.classList.remove('hidden')
      } else {
        icon.classList.remove('hidden', 'search-active')
      }
    }

    if (this.isSearchBoxVisible) {
      this.setAttribute('search-visible', 'true')
    } else {
      this.removeAttribute('search-visible')
    }

    console.log('Setting search-visible attribute', this.isSearchBoxVisible)
  }

  private dispatchSearchStateEvent() {
    const searchStateEvent = new CustomEvent('search-state-changed', {
      bubbles: true,
      composed: true,
      detail: {
        visible: this.isSearchBoxVisible,
        component: this,
      },
    })

    this.dispatchEvent(searchStateEvent)
  }

  private onIconClick = (ev: Event) => {
    ev.preventDefault()

    const iconClickedEvent = new CustomEvent('search-icon-clicked', {
      bubbles: true,
      composed: true,
      detail: {
        component: this,
      },
    })
    this.dispatchEvent(iconClickedEvent)

    this.toggleSearchBox()
  }

  private onIconKeydown = (ev: KeyboardEvent) => {
    if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
      ev.preventDefault()
      this.toggleSearchBox()
    }
  }

  private onDocumentClick = (event: MouseEvent) => {
    if (!this.isSearchBoxVisible) return

    const path = (event as any).composedPath?.() || [event.target]

    const clickedOnIcon = path.some((el: any) => el?.classList?.contains('header-icon'))

    const clickedInSearch = path.some((el: any) => {
      if (!(el instanceof HTMLElement)) return false
      return el.tagName.toLowerCase() === 'ts-searchbox'
    })

    if (!clickedOnIcon && !clickedInSearch) {
      this.isSearchBoxVisible = false
      this.eventStateChange()
      document.removeEventListener('click', this.onDocumentClick, true)
    }
  }

  private toggleSearchBox() {
    this.isSearchBoxVisible = !this.isSearchBoxVisible
    this.eventStateChange()

    if (this.isSearchBoxVisible) {
      document.addEventListener('click', this.onDocumentClick, true)
    } else {
      document.removeEventListener('click', this.onDocumentClick, true)
    }
  }
}

if (!customElements.get('ts-navheader-utility-search')) {
  customElements.define('ts-navheader-utility-search', NavHeaderUtilitySearch)
}

export { NavHeaderUtilitySearch }
